import React from 'react';
import {Modal, View, Platform} from 'react-native';
import moment from 'moment';

import Text from '../../elements/Text';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {BUTTON_TYPES} from '../../../utils/Constants';
import Button from '../../elements/Button';
import {tID} from '../../../utils/TestIdHelper';
import {CalendarIcon} from '../../../utils/SvgIcons';
import CommonStyles from '../../../utils/CommonStyles';
import {useTimeFormat} from '../../../hooks/useTimeFormat';

const ViewNoteModal = ({
  note,
  visible,
  onRequestClose,
  onEdit,
  listView = false,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const timeFormat = useTimeFormat();

  const formatDateTime = (date) => {
    const momentDate = moment(date);
    const timeStr = timeFormat === '12'
      ? momentDate.format('hh:mm A')
      : momentDate.format('HH:mm');
    return `${momentDate.format('dddd')} ${momentDate.format('MM/DD/YY')}, ${timeStr}`;
  };

  return (
    <Modal
      testID={tID('ViewNoteModal-Modal-Main')}
      animationType="fade"
      transparent={true}
      visible={visible}
      onRequestClose={onRequestClose}>
      <View
        testID={tID('ViewNoteModal-View-Container')}
        style={[
          styles.centeredView,
          Platform.OS === 'web' && styles.webContainer,
        ]}>
        <View
          style={[
            styles.modalView,
            Platform.OS === 'web' && styles.detailsContainer,
          ]}>
          <View style={styles.headerContainer}>
            <Text
              testID={tID('ViewNoteModal-Text-Title')}
              variation="Body1SemiBold"
              color={colors.textHeading}>
              {note.title}
            </Text>
            <View style={styles.titleContainer}>
              <CalendarIcon style={CommonStyles.mr_10} />
              <Text
                testID={tID('ViewNoteModal-Text-DateTime')}
                variation="Subtitle2Regular"
                color={colors.textHeading}>
                {formatDateTime(note.createAt)}
              </Text>
            </View>
          </View>
          <Text
            testID={tID('ViewNoteModal-Text-Description')}
            variation="Body1Regular"
            color={colors.textPrimary}
            topMargin={16}
            style={styles.margin16}>
            {note.noteText}
          </Text>
          <View style={styles.buttonsContainer}>
            <Button
              testID={tID('ViewNoteModal-Button-Close')}
              style={styles.leftButton}
              title={'Close'}
              onPress={onRequestClose}
            />
            {!listView && (
              <Button
                testID={tID('ViewNoteModal-Button-Edit')}
                style={styles.rightButton}
                title={'Edit'}
                buttonType={BUTTON_TYPES.Filled}
                titleColor={colors.textOnAccent}
                onPress={onEdit}
              />
            )}
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ViewNoteModal;
